import { render } from "./BrowserView.vue?vue&type=template&id=ac540450&scoped=true"
import script from "./BrowserView.vue?vue&type=script&lang=js"
export * from "./BrowserView.vue?vue&type=script&lang=js"

import "./BrowserView.vue?vue&type=style&index=0&id=ac540450&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac540450"

export default script